import React, { useEffect, useState } from 'react';

const VoucherLog = () => {
  const [rewards, setRewards] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [rewardId, setRewardId] = useState('');
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');

  // Filters
  const [filterReward, setFilterReward] = useState('');
  const [searchCode, setSearchCode] = useState('');

  // Fetch rewards
  useEffect(() => {
    fetch('https://loyaltyprogram.navalsupermart.com/api/rewards.php')
      .then(res => res.json())
      .then(data => setRewards(data))
      .catch(err => console.error('Failed to fetch rewards:', err));
  }, []);

  // Fetch existing vouchers
  const loadVouchers = () => {
    fetch('https://loyaltyprogram.navalsupermart.com/api/voucher_templates.php')
      .then(res => res.json())
      .then(data => setVouchers(data))
      .catch(err => console.error('Failed to fetch vouchers:', err));
  };

  useEffect(() => {
    loadVouchers();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('reward_id', rewardId);
    formData.append('code', code);

    fetch('https://loyaltyprogram.navalsupermart.com/api/add_predefined_voucher.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage(`✅ Voucher created: ${data.code}`);
          setCode('');
          setRewardId('');
          loadVouchers();
        } else {
          setMessage(`❌ ${data.message}`);
        }
      })
      .catch(() => setMessage('❌ Error submitting form.'));
  };

  const handleDelete = (voucherCode) => {
    if (!window.confirm(`Delete voucher "${voucherCode}"?`)) return;

    const formData = new FormData();
    formData.append('code', voucherCode);

    fetch('https://loyaltyprogram.navalsupermart.com/api/delete_voucher.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage(`🗑️ Voucher "${voucherCode}" deleted.`);
          loadVouchers();
        } else {
          setMessage(`❌ ${data.message}`);
        }
      })
      .catch(() => setMessage('❌ Failed to delete voucher.'));
  };

  // Filtered vouchers based on dropdown & search
  const filteredVouchers = vouchers.filter(v =>
    (filterReward === '' || v.reward_name === filterReward) &&
    v.code.toLowerCase().includes(searchCode.toLowerCase())
  );

  return (
    <div>
      <h2>Create Predefined Voucher</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Select Reward:
          <select value={rewardId} onChange={(e) => setRewardId(e.target.value)} required>
            <option value="">-- Select Reward --</option>
            {rewards.map((reward) => (
              <option key={reward.id} value={reward.id}>
                {reward.name} (₱{reward.discount_value})
              </option>
            ))}
          </select>
        </label>

        <br /><br />

        <label>
          Voucher Code:
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            maxLength={20}
            placeholder="e.g. ABC50XYZ"
          />
        </label>

        <br /><br />
        <button type="submit">Create Voucher</button>
      </form>

      {message && <p style={{ marginTop: '1rem' }}>{message}</p>}

      <hr />

      <h2>Filter Vouchers</h2>
      <label>
        Reward:
        <select value={filterReward} onChange={(e) => setFilterReward(e.target.value)}>
          <option value="">-- All --</option>
          {rewards.map(r => (
            <option key={r.id} value={r.name}>{r.name}</option>
          ))}
        </select>
      </label>

      <label style={{ marginLeft: '20px' }}>
        Code:
        <input
          type="text"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value)}
          placeholder="e.g. ABC"
        />
      </label>

      <hr />
      <h2>Existing Vouchers</h2>
      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Code</th>
            <th>Reward</th>
            <th>Amount</th>
            <th>Issued</th>
            <th>Valid Until</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredVouchers.length === 0 ? (
            <tr><td colSpan="6">No vouchers match filter.</td></tr>
          ) : (
            filteredVouchers.map(v => (
              <tr key={v.code}>
                <td>{v.code}</td>
                <td>{v.reward_name}</td>
                <td>₱{v.discount_value}</td>
                <td>{v.issued_date}</td>
                <td>{v.valid_until}</td>
                <td>
                  <button onClick={() => handleDelete(v.code)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VoucherLog;
